import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "@/store";
import ElementUI from 'element-ui';
import echarts from 'echarts';
import Viewer from 'v-viewer';
import {initMenu} from "@/utils/menus";
import modal from '@/utils/modal'
// import Plugin from 'v-fit-columns';
import './directives/dialogDrag'//全局引入v-dialogDrag自定义指令


import 'element-ui/lib/theme-chalk/index.css';
import './static/asert/css/index.css';
import './static/asert/css/theme-1.css';
import './static/asert/css/page.css';
import './static/asert/css/dialog.css';

import 'viewerjs/dist/viewer.css';


Vue.config.productionTip = false;
Vue.use(ElementUI);
// Vue.use(Plugin);

// 模态框对象
Vue.prototype.$modal = modal


Vue.prototype.$echarts = echarts;
Vue.use(Viewer)
Viewer.setDefaults({  //默认样式，可以按需求更改
    Options: { 'inline': false, 'button': false, 'navbar': false, 'title': false, 'toolbar': false, 'tooltip': false,
        'movable': false, 'zoomable': false, 'rotatable': false, 'scalable': false, 'transition': false, 'fullscreen': false,
        'keyboard': false, 'url': 'data-source' }
})

router.beforeEach( async (to, from, next) => {
    console.log(to.path)

    if (to.path === '/video-monitors-meta/live-video') {
        window.open('https://vcp.21cn.com/vcpbs/web/index.html#/video-monitors-meta/live-video', '_blank');
        next(false); // 取消当前导航
    } else if (to.path === '/video-monitors-meta/live-video1') {
        window.open('https://fa.zhenshanyl.com/', '_blank');
        next(false); // 取消当前导航
    } else if (to.path === '/video-monitors-meta/live-video2') {
        window.open('https://saas.shangtiiot.cn', '_blank');
        next(false); // 取消当前导航
    } else if (to.path === '/call/testAAAAA') {
        window.open('https://www.yongaimujia.com/call/test', '_blank');
        next(false); // 取消当前导航
    } else {
        if (store.state.is === true) {
            await initMenu(router, store); // 异步加载菜单栏
            store.commit('CHANGESTORE', false);
            if (to.meta.title) {
                document.title = to.meta.title
            }
            next();
        } else {
            if (to.meta.title) {
                document.title = to.meta.title
            }
            next();
        }
    }

})


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')